import { render, staticRenderFns } from "./icon.vue?vue&type=template&id=825889ee&scoped=true&"
import script from "./icon.vue?vue&type=script&lang=ts&"
export * from "./icon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "825889ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\VelipetteriLehto\\Projects\\Europress\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('825889ee')) {
      api.createRecord('825889ee', component.options)
    } else {
      api.reload('825889ee', component.options)
    }
    module.hot.accept("./icon.vue?vue&type=template&id=825889ee&scoped=true&", function () {
      api.rerender('825889ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/component/bulma/icon.vue"
export default component.exports